export const FEE_OVERRIDE_LEVELS = {
  account: {
    label: 'Account',
    value: 'ACCOUNT'
  },
  class: {
    label: 'Asset Classes',
    value: 'ASSET_CLASS'
  },
  position: {
    label: 'Position',
    value: 'POSITION'
  }
}

export const FEE_OVERRIDE_LEVEL_VALUES = Object.entries(FEE_OVERRIDE_LEVELS).reduce(
  (acc, [key, value]) => ({ ...acc, [key]: value.value }),
  {}
)

export const FEE_LEVEL_OVERRIDE_OPTIONS = Object.values(FEE_OVERRIDE_LEVELS).map(
  ({ label, value }) => ({ label, value, rules: { max: 50 } })
)

export const findOverrideOption = (value) => {
  return FEE_LEVEL_OVERRIDE_OPTIONS.find(x => value === x.value)
}

export const getFeeOverrideCounters = (feeOverrides) => {
  return feeOverrides.reduce((acc, { feeOverrideType }) => {
    return feeOverrideType
      ? {
        ...acc,
        [feeOverrideType]: (acc[feeOverrideType] || 0) + 1
      }
      : acc
  }, {})
}

export const mapAndValidateLevelOverrideOptions = (feeOverrides, levelOptions) => {
  const overrideCounters = getFeeOverrideCounters(feeOverrides)
  const { levelOverrideOptions } = levelOptions.reduce(
    (acc, levelOption) => {
      const { value: levelValue, rules: levelRules } = levelOption
      const overrideCount = acc.overrideCounters[levelValue] || 0
      const levelOverrideRules = levelRules

      if (overrideCount >= levelOverrideRules.max) {
        acc.levelOverrideOptions.push({
          ...levelOption,
          disabled: true
        })
      } else {
        acc.levelOverrideOptions.push(levelOption)
      }
      return acc
    },
    { levelOverrideOptions: [], overrideCounters }
  )
  return levelOverrideOptions
}
